import React from "react";
import { Button, Drawer, Space } from "antd";
import { FONT } from "constants/index";
import { CircleX } from "lucide-react";
import useBreakpoint from "hooks/useBreakpoint";
import { drawerWidth } from "util/responsive";

const DrawerApp = (props) => {
  const { isMobile } = useBreakpoint();
  const resolvedWidth =
    props.width !== undefined ? props.width : drawerWidth(isMobile, 65);

  const extraContent = props.isOnlyView ? (
    <Space wrap className={isMobile ? "drawer-extra-mobile" : ""}>
      {props.extra}
    </Space>
  ) : (
    <Space wrap className={isMobile ? "drawer-extra-mobile" : ""}>
      {props.extra}
      <Button style={{ fontFamily: FONT }} onClick={props.onClose}>
        Cancelar
      </Button>
      <Button
        style={{ fontFamily: FONT }}
        onClick={props.actionSave}
        type="primary"
      >
        Salvar
      </Button>
    </Space>
  );

  return (
    <Drawer
      title={props.title}
      size={props.size}
      onClose={props.onClose}
      open={props.open}
      style={{ fontFamily: FONT }}
      closeIcon={<CircleX size={18} />}
      width={resolvedWidth}
      placement={props.placement || "right"}
      extra={extraContent}
    >
      {props.body}
    </Drawer>
  );
};

export default DrawerApp;
